import {getNodePrintedData, getQueryParam, paths} from "./helpers";

jQuery(() => {
  initPage();
  initManageUsersPage();
  initDeletePage();
  initConfirmRevertPage();
  initEditUserPage()
  initDeleteUserPage()
  initManageTaxPermPage()
});

let node = {};

function initPage() {
  if (jQuery('.backoffice-page').length === 0) return;
  node = getNodePrintedData();
  jQuery('body').addClass('backoffice-body');

  const $closeBtn = jQuery('#close-backoffice');
  const $submitBtn = jQuery('#public-content-btn, #save-content-btn');
  const $deleteBtn = jQuery('#delete-btn');
  $closeBtn.on('click', function () {
    if (jQuery('.node-comunicazioni-form ').length > 0) {
      window.location.href = window.location.origin + paths.updates;
    } else if (jQuery('#node-creation-form, #node-edit-form').length > 0) {
      window.location.href = window.location.origin + paths.manageContent;
    } else if (jQuery('#settings-page').length > 0) {
      window.location.href = window.location.origin;
    } else {
      history.back();
    }
  })
  $submitBtn.on('click', function () {
    jQuery('#edit-submit').click();
  })
  $deleteBtn.on('click', function () {
    openDeleteModal();
  })

  const $backFromSuccessPageBtn = jQuery('#back-to-content-from-success');
  const $successPageContent = jQuery('#success-creation-page-content')
  const isSuccessPageComunicazioni = getQueryParam('ntype') === 'comunicazioni';

  if (isSuccessPageComunicazioni) {
    $backFromSuccessPageBtn.text('Torna alle comunicazioni');
    jQuery('h2', $successPageContent).text('Comunicazione aggiunta con successo')
  }
  $successPageContent.removeClass('hidden');
  $backFromSuccessPageBtn.on('click', function () {
    const destination = isSuccessPageComunicazioni ? paths.updates : paths.manageContent
    window.location.href = window.location.origin + destination;
  })

  jQuery('.pager')
    .attr('id', 'pager-wrapper')
    .show()

}

function openDeleteModal() {
  jQuery('#edit-delete').click();
}

function initManageUsersPage() {
  if (jQuery('#manage-user-page').length === 0) return;

  const tableTitleRow = `
    <div class="views-row title-row">
        <div></div>
        <div class="font-semibold">
            <div class="views-field text-semibold">Username</div>
        </div>
        <div class="font-semibold">
            <div class="views-field text-semibold">Stato</div>
        </div>
        <div class="font-semibold">
            <div class="views-field text-semibold">Ruolo</div>
        </div>
        <div class="font-semibold">
            <div class="views-field text-semibold">Iscritto da</div>
        </div>
        <div class="font-semibold">
            <div class="views-field text-semibold">Ultimo accesso</div>
        </div>
        <div class="font-semibold">
            <div class="views-field text-semibold">Azioni</div>
        </div>
    </div>
  `
  jQuery(tableTitleRow).insertAfter('#edit-header');

  const $userNameLink = jQuery('.views-field-name a')
  $userNameLink.each(function() {
    const editPageUrl = jQuery(this).parents('.views-row').find('.dropbutton-action a').prop('href')
    jQuery(this).prop('href', editPageUrl)
  })
}

function initDeletePage() {
  if (jQuery('#node-delete-wrapper').length === 0) return;

  jQuery('#confirm-delete').on('click', function () {
    jQuery('#edit-submit').click()
  })
  jQuery('#clear-cancel').on('click', function () {
    history.back();
  })
}

function initConfirmRevertPage() {
  if (jQuery('#node-revision-revert-confirm').length > 0) {
    const title = `
      <h1 class="font-semibold text-xl text-jumbo-950 mb-5">Sei sicuro di voler ripristinare la revisione?</h1>
    `
    jQuery(title).insertBefore('#edit-actions')
  }
  if (jQuery('#node-revision-delete-confirm').length > 0) {
    const title = `
      <h1 class="font-semibold text-xl text-jumbo-950 mb-1">Sei sicuro di voler eliminare la revisione?</h1>
    `
    jQuery('#node-revision-delete-confirm').prepend(title)
  }
}

function initEditUserPage() {
  if (jQuery('#edit-user-page').length === 0) return;

  jQuery('#save-user-btn').on('click', function () {
    jQuery('#edit-submit').click()
  });

  jQuery('#delete-user-btn').on('click', function () {
    const destination = jQuery('#edit-delete').attr('href');
    window.location.href = destination;
  });

}

function initDeleteUserPage() {
  if (jQuery('#delete-user-page').length === 0) return;

  jQuery('#confirm-delete').on('click', function () {
    jQuery('#edit-submit').click()
  });

  jQuery('#clear-cancel').on('click', function () {
    jQuery('#edit-cancel').click()
    window.location.href = paths.users
  });

}

function initManageTaxPermPage() {
  if (jQuery('#manage-taxonomy-permissions-page').length === 0) return;

  jQuery('#save-permissions-btn').on('click', function () {
    jQuery('#edit-submit').click()
  });

}
